module.exports = __webpack_public_path__ + "img/Muito-alem-dos-muros-1300x350.0be8c3f7.png";